import React from 'react';
import ToggleInput from './ToggleInput.react';

export const CheckBoxElement = ({ height, width, selected }) => (
  <svg width={width} height={height} viewBox={ '0 0 ' + (width + 2) + ' ' + (height + 2) } version='1.1'>
  <g stroke='1' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-448.000000, -547.000000)' >
          <g transform='translate(448.000000, 547.000000)'>
            <rect x='1' y='1' width={width * 0.80} height={height * 0.80} rx='2' stroke='#BEBEBE' strokeWidth='1'></rect>
            { selected && <path d='M8.31818182,15.5909091 L12.977456,21.333537' stroke='#1E9DEE' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'></path> }
            { selected && <path d='M21.0454546,7.31818182 L13.1124559,21.4136464' stroke='#1E9DEE' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'></path> }
            { selected && <use stroke='#979797' mask='url(#mask-2)' strokeWidth='2'></use> }
          </g>
      </g>
  </g>
  </svg>
);

const CheckBox = (props) => <ToggleInput element={<CheckBoxElement />} inputType='checkbox' {...props} />;

export default CheckBox;
